<template>
  <div>
    <v-row no-gutters>
        <v-col cols="6" class="ml-4 font18 bold headline2" v-if="member">รางวัลยอดฮิตสัปดาห์นี้</v-col>
        <v-col cols="6" class="ml-4 font18 bold headline2" v-if="!member">รางวัลยอดฮิตสัปดาห์นี้จ่ะ</v-col>
        <v-col class="text-end icon1 pr-8 bold font14 link" v-if="member" @click="$router.push('reward')">
          ดูทั้งหมด
          <v-icon>mdi-chevron-right-circle-outline</v-icon>
        </v-col>
    </v-row>
    <v-card style="border-radius:20px" elevation="5" >
      {{items}}
    <v-carousel
      :show-arrows="false"
      height="253"
      class="mt-2"
      v-if="member"
    >
      <v-carousel-item
        v-for="(item,i) in items"
        :key="i"
        :src="item.pictureUrl"
        reverse-transition="fade-transition"
        transition="fade-transition"
        class="link" @click="$router.push(`/reward/detail/${item.rewardId}`)"
      >
      </v-carousel-item>
    </v-carousel>
    <v-carousel
      :show-arrows="false"
      height="253"
      class="mt-2"
      v-if="member === null"
    >
      <v-carousel-item
        v-for="(item,i) in items"
        :key="i"
        :src="item.pictureUrl"
        reverse-transition="fade-transition"
        transition="fade-transition"
        class="link"
      >
      </v-carousel-item>
    </v-carousel>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'TrendingWeek',
  data () {
    return {
      items: null,
      member: null,
      profile: null,
      DateNow: new Date(),
      session: this.$session.getAll(),
      shopId: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()

    await this.getReward()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    async getReward () {
      alert('getReward')
      const result = await axios.get(this.DNS_IP + `/reward/line/get?shopId=${this.shopId}&RECORD_STATUS=N&trending=True&quota=0`, { headers: {lineUserId: this.profile.userId, shopId: this.shopId} })
      if (result.data.length > 0) {
        this.items = result.data.filter((item) => { return item.expireType === 'Redeem' })
        this.items.push(...result.data.filter((item) => { return item.expireType === 'FixDate' }).filter(a => new Date(a.EndDate).getTime() > this.DateNow.getTime()))
      }
      alert('getReward finish')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TrendingWeek.vue